import { Link } from "react-router-dom";
import HeroIcon from "./HeroIcon";
import { ExternalLinkIcon } from "@heroicons/react/outline";

interface Props {
  icon?: string;
  name: string
  href: string;
  isExpanded: boolean;
  isSelected: boolean;
  isHidden?: boolean;
  isExternal?: boolean;
  isBeta?: boolean;
  isNew?: boolean;
  bucketIcon?: string;
}

function SidebarItem(props: Props) {
  if (props.isHidden)
    return null;

  return (
    <Link to={props.isExternal ? { pathname: props.href } : props.href} className={`group relative flex items-center gap-2 font-semibold px-3 py-2 mx-4 rounded-md cursor-pointer text-gray-600 ${props.isSelected ? 'bg-gray-50 hover:bg-gray-50' : ' hover:bg-gray-50'}`} target={props.isExternal ? "_blank" : ""}>
      <div className={`absolute bg-blue left-0 h-full w-1 rounded-l ${props.isSelected ? 'visible' : 'invisible'}`} style={{ background: "linear-gradient(180deg, #0E43DC 0%, #026AE7 33.17%, #0080E3 66.83%, #A1CDF1 100%), #1875FB" }}></div>
      {props.bucketIcon
        ? <img src={props.bucketIcon} className='w-5 h-5' alt="Sidebar icon" />
        : <HeroIcon icon={props.icon ?? "CubeTransparent"} className='w-5 h-5' />
      }
      {props.isExpanded
        ? <div className="flex items-center gap-1 text-sm leading-none text-gray-900">{props.name}{props.isExternal && <ExternalLinkIcon className="w-4 h-4 text-gray-400" />}</div>
        : <div className="flex items-center gap-1 invisible group-hover:visible text-sm absolute left-8 text-gray-900 text-nowrap p-2 pl-2 pr-4 rounded bg-gray-50">{props.name}{props.isExternal && <ExternalLinkIcon className="w-4 h-4 text-gray-400" />}</div>
      }
      {(props.isBeta && props.isExpanded) &&
        <div className="text-xs bg-lightblue text-blue pt-0.5 px-1 w-10 text-center rounded ml-auto">BETA</div>
      }
      {(props.isNew && props.isExpanded) &&
        <div className="text-xs bg-blue text-white pt-0.5 px-1 w-10 text-center rounded ml-auto">NEW</div>
      }
    </Link>
  );
};

export default SidebarItem;
